import { OrmModel, StringField, AttrField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'
import type { LabelColor, LabelStyle } from '@/services/domain/label/types'

@OrmModel(modelNames.LABEL)
export default class Label extends BaseModel {
  @StringField()
  public id: string

  @StringField()
  public name: string

  @StringField()
  public color: LabelColor

  @StringField()
  public style: LabelStyle

  @AttrField(null)
  public attachmentsCount: number | null
}
